import { AxiosHeaders } from "axios";
import api from "./api";
import { serviceMain } from "./serviceMain";

export type RegisterUser = {
  FirstName: string;
  LastName: string;
  SignInName: string;
  Email: string;
  Password: string;
  MobilePhone: string;
  NationalIdNumber: string;
  StoreCode?: string;
  GroupId?: string;
  OverrideIdCreatorPlatformType: number;
}

export async function registerUser(request: RegisterUser) {

  const headers: AxiosHeaders = new AxiosHeaders()
  headers.set('Content-Type', 'application/json');
  headers.set('Access-Control-Allow-Origin', '*');
  headers.set('Accept', 'application/json');

  let status: number = 0;

  await api.post('/v3/account/registerUserAndCustomer', JSON.stringify(request), { headers: headers })
  .then((response)=> {
    status = response?.status;
  })

  if(status === 200){
    return 'OK'
  }else{
    return 'KO'
  }

};